<!--
 * @Description: 会员管理
-->
<template>
  <div>
    <div class="TableTop">
      <!-- 搜索 -->
      <div class="TableSearch">
        <el-form :model="query" @submit.native.prevent>
          <!-- 产品名 -->
          <el-form-item label="手机号：" class="form-item-b0">
            <el-input v-model="query.phone" placeholder="请输入手机号" maxlength="11" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="TableSearch_btn">
          <el-button type="primary" size="small" @click="filterList">筛选</el-button>
          <el-button type="primary" size="small" @click="reload">刷新</el-button>
        </div>
      </div>

      <div>
        <span>总积分：{{ sum + sumIntegral }}</span>
        <span style="margin-left: 20px">剩余总积分：{{ sum }}</span>
        <span style="margin-left: 20px">已兑换总积分：{{ sumIntegral }}</span>
      </div>
    </div>

    <!-- 表格 -->
    <el-table ref="TableListRef" class="TableList" border :data="integralList" v-loading="loading">
      <el-table-column prop="Id" label="Id" width="80" align="center"></el-table-column>

      <el-table-column prop="LoginName" label="手机号" align="center"></el-table-column>

      <el-table-column prop="Integral" label="积分" align="center"></el-table-column>

      <el-table-column prop="topUp" label="流水" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="getTopUpWaterList(scope.row.LoginName)"> 流水 </el-button>
        </template>
      </el-table-column>

      <el-table-column prop="access" label="访问" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="getAccessList(scope.row.LoginName)"> 访问 </el-button>
        </template>
      </el-table-column>

      <el-table-column prop="OrderCount" label="订单数" align="center"></el-table-column>

      <el-table-column label="操作" align="center" width="140" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="getUserOrderList(scope.row)"> 订单 </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="fenye">
      <el-pagination
        class="TablePagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.pageindex"
        :page-sizes="[10, 20, 40, 60, 100]"
        :page-size="query.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- <ShowTableInfo
      ref="ShowTableInfoRef"
      :showItem="showItem"
      :getListFn="getListFn"
      :param="query"
      @returnData="returnData"
    >
      <template slot="topUp" slot-scope="scope">
        <el-button type="primary" size="mini" @click="getTopUpWaterList(scope.data.LoginName)"> 流水 </el-button>
      </template>

      <template slot="orderNumber" slot-scope="scope">
        <span>{{ scope.data.orderNumber || 0 }}</span>
      </template>

      <template slot="access" slot-scope="scope">
        <el-button type="primary" size="mini" @click="getAccessList(scope.data.LoginName)"> 访问 </el-button>
      </template>

      <template slot="btn" slot-scope="scope">
        <el-button type="primary" size="mini" @click="getUserOrderList(scope.data)"> 订单 </el-button>
      </template>
    </ShowTableInfo> -->

    <el-dialog
      :visible.sync="orderDialog"
      class="FormDialogBox"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
      @close="orderDialogClose"
    >
      <div style="min-height: 560px">
        <div style="font-weight: bold">
          <span>全部积分:{{ orderParam.integral + orderParam.exchangeIntegral || 0 }}</span>
          <span style="margin-left: 20px">剩余积分:{{ orderParam.integral || 0 }}</span>
          <span style="margin-left: 20px">已兑换积分:{{ orderParam.exchangeIntegral || 0 }}</span>
        </div>
        <ShowTableInfo
          ref="ShowTableInfoRef2"
          :underPagination="false"
          :showItem="showItem2"
          :getListFn="getListFn2"
          :param="orderParam"
          :paramChangeGetList="true"
        >
          <template slot="ReceiveAddress" slot-scope="scope">
            <div>{{ scope.data.ReceiveName }} {{ scope.data.ReceivePhone }}</div>
            <div>{{ scope.data.ReceiveAddress }}</div>
          </template>

          <template slot="Status" slot-scope="scope">
            <span :style="{ color: `${scope.data.Status == 0 ? 'red' : ''}` }">{{
              statusType[scope.data.Status]
            }}</span>
          </template>

          <template slot="CreateTime" slot-scope="scope">
            <span>{{ new Date(scope.data.CreateTime) | parseTime('{y}-{m}-{d} {h}:{m}') }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="topUpDialog"
      class="FormDialogBox"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      @close="topUpDialogClose"
    >
      <div style="min-height: 500px">
        <ShowTableInfo
          ref="ShowTableInfoRef3"
          :underPagination="false"
          :showItem="showItem3"
          :getListFn="getListFn3"
          :param="topUpParam"
          :paramChangeGetList="true"
        >
          <template slot="CreateDate" slot-scope="scope">
            <span>{{ new Date(scope.data.CreateDate) | parseTime('{y}-{m}-{d} {h}:{m}') }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="accessDialog"
      class="FormDialogBox"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
      @close="accessDialogClose"
    >
      <div style="min-height: 500px">
        <ShowTableInfo
          ref="ShowTableInfoRef4"
          :underPagination="false"
          :showItem="showItem4"
          :getListFn="getListFn4"
          :param="accessParam"
          :paramChangeGetList="true"
          :showPagination="false"
          :sortListFn="sortListFn"
        >
          <template slot="Date" slot-scope="scope">
            <span>{{ scope.data.Date }}</span>
            <span style="margin-left: 10px">{{ scope.data.Date | parseTime(`星期{a}`) }}</span>
          </template>

          <template slot="VipTime" slot-scope="scope">
            <span>{{ new Date(scope.data.VipTime) | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </ShowTableInfo>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],

      loading: true,
      total: 0,

      query: {
        pageindex: 1,
        pagesize: 20,
        phone: '',
        isIntegral: 1,
        reload: 0
      },

      sum: 0,
      sumIntegral: 0,

      showItem: [
        {
          prop: 'Id',
          label: 'Id',
          width: '80'
        },
        {
          prop: 'LoginName',
          label: '手机号'
        },

        {
          prop: 'Integral',
          label: '积分'
        },
        {
          prop: 'topUp',
          label: '流水'
        },
        {
          prop: 'access',
          label: '访问'
        },
        {
          prop: 'OrderCount',
          label: '订单数'
        }
      ],

      orderDialog: false,
      orderParam: {
        pageindex: 1,
        pagesize: 20,
        userId: '',
        integral: 0
      },
      orderList: [],
      showItem2: [
        {
          prop: 'OrderNo',
          label: '订单号'
        },
        {
          prop: 'SpecName',
          label: '兑换'
        },
        {
          prop: 'ReceiveAddress',
          label: '收货地址'
        },
        {
          prop: 'OrderIntegral',
          label: '积分'
        },
        {
          prop: 'FCount',
          label: '数量'
        },
        {
          prop: 'Status',
          label: '状态'
        },
        {
          prop: 'CreateTime',
          label: '创建时间'
        }
      ],

      statusType: {
        0: '未支付',
        1: '未发货',
        2: '已发货'
      },

      showItem3: [
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'GiveIntegral',
          label: '赠送积分'
        },
        {
          prop: 'Price',
          label: '价格'
        },
        {
          prop: 'CreateDate',
          label: '支付日期'
        },
        {
          prop: 'Remark',
          label: '备注'
        }
      ],
      topUpDialog: false,
      topUpParam: {
        pageindex: 1,
        pagesize: 20,
        search: '',
        status: 1
      },

      showItem4: [
        {
          prop: 'Date',
          label: '日期'
        },
        {
          prop: 'LoginName',
          label: '手机号'
        },
        {
          prop: 'VipTime',
          label: '会员'
        },
        {
          prop: 'LogCount',
          label: '访问次数'
        }
      ],
      accessDialog: false,
      accessParam: {
        begindate: this.$globalFun.parseTime(
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 10),
          '{y}-{m}-{d}'
        ),
        enddate: this.$globalFun.parseTime(new Date(), '{y}-{m}-{d}'),
        pageindex: 1,
        search: ''
      }
    }
  },

  created() {
    this.getListFn({
      ...this.query,
      pagesize: 10000
    }).then((res) => {
      console.log('getListFn111111', res)
      this.total = res.data.count
      this.sum = res.data.sum
      this.sumIntegral = res.data.sumIntegral

      const list1 = res.data.list
        .filter((item) => {
          return item.OrderCount > 0
        })
        .sort((a, b) => {
          return b.OrderCount - a.OrderCount
        })
      const list2 = res.data.list
        .filter((item) => {
          return item.OrderCount === 0
        })
        .sort((a, b) => {
          return b.Integral - a.Integral
        })

      this.list = [...list1, ...list2]

      this.loading = false
    })
  },

  computed: {
    integralList() {
      console.log('integralList', this.list, this.query.pageindex, this.query.pagesize)
      return this.list.slice(
        (this.query.pageindex - 1) * this.query.pagesize,
        this.query.pageindex * this.query.pagesize
      )
    }
  },

  methods: {
    returnData(data) {
      console.log('returnData', data)
      this.sum = data.sum
      this.sumIntegral = data.sumIntegral
    },
    getListFn(query) {
      console.log('getListFn', query)
      if (!query.phone) {
        delete query.phone
      }
      return this.$api.integral.userIntegral(query)
    },
    filterList() {
      this.$refs.ShowTableInfoRef.getList()
    },
    reload() {
      this.query = {
        ...this.query,
        reload: this.query.reload + 1
      }

      this.$refs.ShowTableInfoRef.getList()
    },

    getListFn2(query) {
      return this.$api.order.list(query)
    },

    async getUserOrderList(row) {
      const query = {
        pageindex: 1,
        pagesize: row.OrderCount,
        userId: row.Id
      }
      let exchangeIntegral = 0
      try {
        const res = await this.$api.order.list(query)
        res.data.list.forEach((item) => {
          exchangeIntegral += item.OrderIntegral
        })
      } catch (error) {
        console.log('error', error)
      }

      this.orderParam = {
        ...this.orderParam,
        userId: row.Id,
        exchangeIntegral,
        integral: row.Integral
      }

      this.orderDialog = true
    },

    orderDialogClose() {
      this.orderDialog = false
      this.orderList = []
    },

    getListFn3(query) {
      return this.$api.members.getTopUpWaterList(query)
    },

    getTopUpWaterList(search) {
      this.topUpParam = {
        ...this.topUpParam,
        search
      }

      this.topUpDialog = true
    },

    topUpDialogClose() {
      this.topUpDialog = false
    },

    getListFn4(query) {
      return this.$api.user.loglist(query)
    },

    sortListFn(list) {
      console.log('sortListFn111', list)
      return list.sort((a, b) => {
        return new Date(b.Date).getTime() - new Date(a.Date).getTime()
      })
    },

    getAccessList(search) {
      console.log('getAccessList', search)
      this.accessParam = {
        ...this.accessParam,
        search
      }

      this.accessDialog = true
    },

    accessDialogClose() {
      this.accessDialog = false
    },

    // 每页显示条数和当前页码
    handleSizeChange(newSize) {
      this.query.pagesize = newSize

      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    },
    handleCurrentChange(newPage) {
      this.query.pageindex = newPage

      this.$nextTick(() => {
        this.$refs.TableListRef.bodyWrapper.scrollTop = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table .cell {
    line-height: 26px !important;
  }
}
</style>
